module.exports = __webpack_public_path__ + "static/media/main.61a8bb39.png";